import type { CustomerSegment } from '../types'

export interface CustomerLogo {
  name: string
  src: string
  forceDark?: boolean
}

export const CUSTOMER_LOGOS: Record<Exclude<CustomerSegment, 'all'>, CustomerLogo[]> = {
  university: [
    { name: 'DeVry University', src: '/images/logos/devry.svg' },
    { name: '2U', src: '/images/logos/2u.png', forceDark: true },
  ],
  bootcamp_workforce: [
    { name: 'Fullstack Academy', src: '/images/logos/fullstack-academy-white.png', forceDark: true },
    { name: 'ACI Learning', src: '/images/logos/aci-learning.png' },
    { name: 'Break Through Tech', src: '/images/logos/break-through-tech.svg' },
    { name: 'Climb Hire', src: '/images/logos/climb-hire.svg' },
    { name: 'COOP Careers', src: '/images/logos/coop-careers.png' },
    { name: '2U', src: '/images/logos/2u.png', forceDark: true },
  ],
}

export function logosForSegment(segment: CustomerSegment | null | undefined): CustomerLogo[] {
  if (segment === 'university') return CUSTOMER_LOGOS.university
  if (segment === 'bootcamp_workforce') return CUSTOMER_LOGOS.bootcamp_workforce
  // 2U appears in both segments; the combined bar lists each customer once.
  const seen = new Set<string>()
  return [...CUSTOMER_LOGOS.university, ...CUSTOMER_LOGOS.bootcamp_workforce].filter((logo) => !seen.has(logo.name) && seen.add(logo.name))
}
